import { createContext, useContext, useRef, useState } from 'react';

import { DialogUnAuth } from './DialogUnAuth';
import PortalSentry, { PortalSentryProps } from './portal-sentry';
import { PortalSentryRef } from './type';

const defaultValuePortalSentryRef: PortalSentryRef | null = null;

const context = createContext<{ current: PortalSentryRef | null }>({
  current: defaultValuePortalSentryRef,
});

export function usePortalSentry() {
  return useContext(context);
}

type PropsProviderPortalSentry = {
  children: React.ReactNode;
} & PortalSentryProps;

export function ProviderPortalSentry({
  children,
  ...restProps
}: PropsProviderPortalSentry) {
  const ref = useRef<PortalSentryRef | null>(defaultValuePortalSentryRef);
  const [sentryMounted, setSentryMounted] = useState(false);
  return (
    <context.Provider value={ref}>
      <DialogUnAuth />
      <PortalSentry
        ref={ref}
        onMounted={() => setSentryMounted(true)}
        {...restProps}
      />
      {sentryMounted && children}
    </context.Provider>
  );
}
